import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-shopping-cart-empty',
  imports: [RouterModule, NzEmptyModule],
  templateUrl: './shopping-cart-empty.html',
  styleUrl: './shopping-cart-empty.scss',
})
export class ShoppingCartEmpty implements OnInit {
  get newArrivalsNo(): string {
    return environment.collection.new_arrivals;
  }

  get bestSellersNo(): string {
    return environment.collection.best_sellers;
  }

  isNewArrivals: boolean = false;
  ngOnInit(): void {
    this.isNewArrivals = Math.random() >= 0.5;
  }
}
